import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ThankYou from "../../../pages/FormSubmissions/ThankYou";
import SurveyFlow from "../../../pages/FormSubmissions/SurveyFlow";
import SurveyIntro from "../../../pages/FormSubmissions/SurveyIntro";
import QuestionPage from "../../../pages/FormSubmissions/QuestionPage";
import PanelErrorPage from "../../../pages/FormSubmissions/PanelErrorPage";

const CampaingSurveyLayout = () => {
  return (
    <Routes>
      <Route path=":formId" element={<SurveyFlow />} />
      <Route path="intro/:formId" element={<SurveyIntro />} />
      <Route path="question/:formId/:questionNumber" element={<QuestionPage />} />
      <Route path="thank-you/:formId" element={<ThankYou />} />
      <Route path="panel-error-page/:formId" element={<PanelErrorPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default CampaingSurveyLayout;
